import ForgetModel from '../views/models/forget';
import ReportsModel from '../views/models/report';
import MemberAgree from '../views/models/business/agree';
import MemberRemove from '../views/models/business/remove';
import MemberImport from '../views/models/business/import';
import MemberReview from '../views/models/business/review';
import UserStatus from '../views/models/user/status';
import UserResend from '../views/models/user/resend';
import UserCreate from '../views/models/user/create';
import LanguageShow from '../views/models/language';
import CompaniesCreate from '../views/models/companies/create';
import CompaniesEdit from '../views/models/companies/edit';
import DeviceRemove from '../views/models/device/remove';
import DeviceCreate from '../views/models/device/create';
import DeviceEditor from '../views/models/device/editor';
import PointsCreate from '../views/models/points/create';
import PointsEditor from '../views/models/points/editor';
import PointsRemove from '../views/models/points/remove';
import PointsEvent from '../views/models/points/event';
import PointsChecked from '../views/models/points/checked';
import GroupsRemove from '../views/models/group/remove';
import GroupsSetting from '../views/models/group/setting';
import GroupsCreate from '../views/models/group/create';
import GroupsLevel from '../views/models/group/level';
import MessageSetting from '../views/models/message/setting';
import MessageCreate from '../views/models/message/create';
import MessageView from '../views/models/message/view';
import MessageRemove from '../views/models/message/remove';
import MessageCopy from '../views/models/message/copy';
import MessageEdit from '../views/models/message/edit';

const Models = {
    'forget-model': <ForgetModel />,
    'report-model': <ReportsModel />,
    'member-agree': <MemberAgree />,
    'member-remove': <MemberRemove />,
    'member-import': <MemberImport />,
    'member-review': <MemberReview />,
    'user-status': <UserStatus />,
    'user-resend': <UserResend />,
    'user-create': <UserCreate />,
    'companies-create': <CompaniesCreate />,
    'companies-edit': <CompaniesEdit />,
    'language-show': <LanguageShow />,
    'device-remove': <DeviceRemove/>,
    'device-create': <DeviceCreate/>,
    'device-edit': <DeviceEditor/>,
    'points-create': <PointsCreate/>,
    'points-editor': <PointsEditor/>,
    'point-remove': <PointsRemove />,
    'point-event': <PointsEvent />,
    'point-checked': <PointsChecked />,
    'group-remove': <GroupsRemove />,
    'group-setting': <GroupsSetting />,
    'group-create': <GroupsCreate />,
    'group-level': <GroupsLevel />,
    'message-setting': <MessageSetting />,
    'message-create': <MessageCreate />,
    'message-view': <MessageView />,
    'message-remove': <MessageRemove />,
    'message-copy': <MessageCopy />,
    'message-edit': <MessageEdit />

};

export default Models;